export const QUERY_KEYS = {
    APPOINTMENT: 'appointment',
    USER_APPOINTMENTS: 'userAppointments',
    MEMBER: 'member',
    USER: 'user',
    USER_SETTINGS: 'userSettings',
    NOTICE: 'notice',
    NOTICES: 'notices',
    USER_AGREEMENTS: 'userAgreements',
}